import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import RegisterService from '../../services/registerService';
import { ToastType, useToast } from '../toast/ToastProvider';
import { Form } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { UtilsService } from '../../services/utilsService';

const Register = () => {
    
    const { t, i18n } = useTranslation();
    const navigate = useNavigate();
    const { showToast } = useToast();
    const [rememberMe, setRememberMe] = useState(false);
    const isRtl = i18n.language === 'he';

    const handleCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setRememberMe(event.target.checked);
    };

    const handleNavigateToLogin = () => {
        navigate('/login');
    };

    const handleNavigateToForgotPassword = () => {
        navigate('/forgot-password');
    };

    const [formData, setFormData] = useState({
        firstName: '',
        lastName: '',
        mobile: '',
        companyId: '',
        companyName: '',
        email: '',
        language: 'en', // default
        password: '',
        confirmPassword: '',
    });

    
    const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        const passwordRegex = /^(?=.*[A-Z])(?=.*\W).{8,}$/;

        if (!passwordRegex.test(formData.password)) {
            showToast(t(`toastMessages.PASSWORD_REQUIREMENTS`), ToastType.Warning);
            return;
        }

        if (formData.password !== formData.confirmPassword) {
            showToast(t(`toastMessages.PASSWORDS_DO_NOT_MATCH`), ToastType.Warning);
            return;
        }

        if (!UtilsService.validatePhoneNumber(formData.mobile)) {
            showToast(t(`toastMessages.ENTER_VALID_PHONE`), ToastType.Warning);
            return;
        }

        try {
            const registerResult = await RegisterService.register(formData);
            if (rememberMe) {
                localStorage.setItem('rememberedEmail', formData.email);
            }

            showToast(t(`toastMessages.REGISTRATION_SUCCESS`), ToastType.Success);
            navigate('/login');
        } catch (error: any) {
            if (error?.response?.status === 409) {
                const serverMessage: string = error.response.data?.message || '';
                if (serverMessage.toLowerCase().includes('company')) {
                    showToast(t(`toastMessages.COMPANY_ALREADY_EXISTS`), ToastType.Warning);
                } else {
                    showToast(t(`toastMessages.EMAIL_ALREADY_EXISTS`), ToastType.Warning);
                }
            } else {
                const serverMessage = error?.response?.data?.message;
                showToast(serverMessage || t(`toastMessages.SOMETHING_WENT_WRONG`), ToastType.Error);
            }
        }
    };


    return (
        <div className="container-scroller">
            <div className="container-fluid page-body-wrapper full-page-wrapper">
                <div className="row w-100 m-0">
                    <div className="content-wrapper full-page-wrapper d-flex align-items-center auth login-bg">
                        <div className="card col-lg-4 mx-auto">
                            <div className="card-body px-5 py-5">
                                <h3 className="card-title text-left mb-3">{t('register')}</h3>
                                <form>
                                    <div className="row">
                                        <div className="col-md-6 form-group">
                                            <label className="text-gray">{t('first-name')}</label>
                                            <input type="text" placeholder={t('first-name')} onChange={handleChange} className="form-control p_input input-bg-dark text-white" name="firstName" />
                                        </div>
                                        <div className="col-md-6 form-group">
                                            <label className="text-gray">{t('last-name')}</label>
                                            <input type="text" placeholder={t('last-name')} onChange={handleChange} className="form-control p_input input-bg-dark text-white" name="lastName" />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-6 form-group">
                                            <label className="text-gray">{t('mobile')}</label>
                                            <input type="number" placeholder={t('mobile')} onChange={handleChange} className="form-control p_input input-bg-dark text-white" name="mobile" />
                                        </div>
                                        <div className="col-md-6 form-group">
                                            <label className="text-gray">{t('language')}</label>
                                            <select
                                                name="language"
                                                onChange={handleChange}
                                                className="form-control p_input input-bg-dark text-white"
                                                value={formData.language}
                                            >
                                                <option value="en">{t('english')}</option>
                                                <option value="he">{t('hebrew')}</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div className="form-group">
                                        <label className="text-gray">{t('company-name')}</label>
                                        <input type="text" placeholder={t('company-name')} onChange={handleChange} className="form-control p_input input-bg-dark text-white" name="companyName" />
                                    </div>
                                    <div className="form-group">
                                        <label className="text-gray">{t('email')}</label>
                                        <input type="email" placeholder={t('email')} onChange={handleChange} className="form-control p_input input-bg-dark text-white" name="email" />
                                    </div>
                                    <div className="form-group">
                                        <label className="text-gray">{t('password')}</label>
                                        <input type="password" placeholder={t('password')} onChange={handleChange} className="form-control p_input input-bg-dark text-white" name="password" />
                                    </div>
                                    <div className="form-group">
                                        <label className="text-gray">{t('confirm-password')}</label>
                                        <input type="password" placeholder={t('confirm-password')} onChange={handleChange} className="form-control p_input input-bg-dark text-white" name="confirmPassword" />
                                    </div>
                                    <div className="form-group d-flex align-items-center justify-content-between">
                                        <Form.Check
                                            type="checkbox"
                                            label={t('remember-me')}
                                            className={`mt-2 text-gray d-flex align-items-center ${isRtl ? 'me-2' : 'ms-2'}`}
                                            id="registerRemember"
                                            checked={rememberMe}
                                            onChange={handleCheckboxChange}
                                        />
                                        <a className="btn btn-link" onClick={handleNavigateToForgotPassword}>{t('forgot-password')}</a>
                                    </div>
                                    <div className="text-center">
                                        <button type="submit" onClick={handleSubmit} className="btn btn-primary btn-block enter-btn">{t('register')}</button>
                                    </div>
                                    <p className="sign-up text-center">
                                        {t('already-have-account')} <a className="btn btn-link" onClick={handleNavigateToLogin}>{t('login')}</a>
                                    </p>
                                    <p className="terms">
                                        {t('accepting-terms')} <a href="#"> {t('terms-conditions')}</a>
                                    </p>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Register;
